import axios from "axios";
// import store from "@/store";
import { Message } from "element-ui";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import router from "@/router";
// import cookie from "@/utils/cookie";
// import configApi from "@/api/config";
// NProgress 配置
NProgress.configure({
  showSpinner: false,
});

if(window.location.host.includes('bgjtsvip.com')){
  var service = axios.create({
    baseURL: 'https://openapi.bgjtsvip.com/store/', // API的基础路径
    timeout: 55000 // 请求超时时间
  });
}else{
  var service = axios.create({
    baseURL: 'https://xh.hnbake.com/store/', // API的基础路径
    timeout: 55000 // 请求超时时间
  });
}
// 创建axios实例
// const service = axios.create({
//   baseURL: process.env.VUE_APP_BASE_API, // API的基础路径
//   timeout: 5000 // 请求超时时间
// });
 
// 请求拦截器
service.interceptors.request.use(
  config => {
    NProgress.start();
    // 在发送请求之前做些什么，例如添加token等
    const token = localStorage.getItem('token_store');
    if (token) {
      config.headers['Authorization'] = `${token}`;
    }
    return config;
  },
  error => {
    // 对请求错误做些什么
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);
 
// 响应拦截器
service.interceptors.response.use(
  response => {
    NProgress.done();
    /**
     * 根据你的项目需求在这里处理响应数据，例如：
     * return response.data; // 直接返回数据部分
     */
    if(response.data.code == 0){
        return response.data;
    }else if(response.data.code == 202){
        let url = encodeURIComponent(window.location.href)
    }else if(response.data.code == 900){
        localStorage.clear();
        setTimeout(function(){
          if(router.currentRoute.fullPath !== '/'){
            router.push({ path: "/"});
          }
        },500)
    }else{
        Message({
          message: response.data.message,
          type: "error",
        });
    }
    
  },
  error => {
    // 对响应错误做点什么
    console.error('Response error:', error);
    return Promise.reject(error);
  }
);
 
export default service;